import { GenericAbortSignal } from 'axios';

import { DenialList } from 'models/DenialList';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type AdminDenialListsIndexParams = BaseIndexQueryParams & {
  clientId?: string;
};

export const adminDenialListsQueryKeys = {
  base: ['adminDenialLists'],
  index: (params: Record<string, any> = {}) => ['adminDenialLists', 'index', params],
};

export async function indexAdminDenialLists(params: AdminDenialListsIndexParams, signal?: GenericAbortSignal) {
  return http.get<Paginated<DenialList>>('/admin/denial_lists', { params, signal }).then((response) => response.data);
}

export async function createAdminDenialList(params: { clientId: string }) {
  return http.post<DenialList>('/admin/denial_lists', params).then((response) => response.data);
}

export async function destroyAdminDenialList(id: string) {
  return http.delete(`/admin/denial_lists/${id}`);
}
